import Vue from 'vue'
import Vuex from 'vuex'

import user from '@/stores/modules/user'
import notification from '@/stores/modules/notification'
import loader from '@/stores/modules/loader'
import config from '@/stores/modules/config'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    notification,
    loader,
    config
  }
})

export default store
